<script>
	export let active;
	import Menu from './Menu.svelte';
	import Footer from './Footer.svelte';
</script>
<main>
	<Menu active={active}/>
	<slot></slot>
	<Footer />
</main>
<aside class="device-orientation">
    <div class="logo"></div>
    <div class="orientation-content">
        <div class="device"></div>
        <p class="title">For a better experience, please rotate your device.</p>
    </div>
</aside>